import React from "react";
import styled, { css, keyframes } from "styled-components";
import { listingCardShadow } from "../ListingCard/styled";

const shimmer = keyframes`
    from {
        transform: translateX(-100%);
    }
    to {
        transform: translateX(100%);
    }
`;

const skeletonBase = css`
    position: relative;
    overflow: hidden;
    background-color: hsl(0, 0%, 95%);

    &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transform: translateX(-100%);
        background-image: linear-gradient(
            90deg,
            hsla(0, 0%, 100%, 0%) 0,
            hsla(0, 0%, 100%, 20%) 20%,
            hsla(0, 0%, 100%, 50%) 60%,
            hsla(0, 0%, 100%, 0%)
        );
        animation: ${shimmer} 1s infinite;
        content: "";
    }
`;

const Outer = styled.div`
    ${listingCardShadow}
    height: 100%;
    background-color: hsl(0, 0%, 100%);
    border-radius: 15px;
    overflow: hidden;
    min-height: 315px;
`;

const Header = styled.div`
    height: 116px;
    background-color: hsl(0, 0%, 95%);
    position: relative;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px;
    height: calc(100% - 116px);
`;

const TitleWrap = styled.div`
    margin-bottom: 4px;
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

const Title = styled.div`
    ${skeletonBase}
    height: 18px;
    border-radius: 4px;
`;

const CopyWrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

const Copy = styled.div`
    ${skeletonBase}
    height: 10px;
    border-radius: 4px;
    background-color: hsl(0, 0%, 95%);
`;

const Footer = styled.div`
    margin-top: auto;
    padding-top: 16px;
    display: flex;
    gap: 8px;
`;

const Button = styled.div`
    ${skeletonBase}
    width: 100%;
    height: 25px;
    border-radius: 5px;
    background-color: hsl(0, 0%, 95%);
`;

export const SkeletonCard = () => {
    return (
        <Outer>
            <Header />
            <Content>
                <TitleWrap>
                    <Title />
                    <Title style={{ width: "50%" }} />
                </TitleWrap>
                <CopyWrap>
                    <Copy />
                    <Copy />
                    <Copy />
                    <Copy style={{ width: "50%" }} />
                </CopyWrap>
                <Footer>
                    <Button />
                </Footer>
            </Content>
        </Outer>
    );
};
